module.exports = __webpack_public_path__ + "img/appointment_b.0905235e.png";